import axios from "./../index";

// 相談対応時の注意点バッジ（自治体連携履歴あり）専用の軽量な存在確認API。
// バックエンド: app/controllers/api/v1/users/municipal_cooperation_existences_controller.rb
// 全件シリアライズする face_sheet_history_summary とは異なり、真偽値のみを返す。

const path = (userId: string) => `/api/v1/users/${userId}/municipal_cooperation_existence`;

export type MunicipalCooperationExistence = {
  hasMunicipalCooperationHistory: boolean;
};

export default {
  fetchMunicipalCooperationExistence(userId: string, config: Record<string, unknown> = {}): Promise<MunicipalCooperationExistence> {
    return axios.get(path(userId), config).then((response) => response.data);
  }
};
